import { LinkActionLink } from '../link/action-link';
import { LinkAssetLink } from '../link/asset-link';
import { LinkExternalLink } from '../link/external-link';
import { LinkInternalLink } from '../link/internal-link';
import { LinkThematischerLink } from '../link/thematischer-link';
import { InternIcon } from './icon';

/**
 * Model definition for Service Link
 */
export interface InternServiceLink {
  __component: 'intern.service-link';
  id: string;
  link: [LinkInternalLink | LinkExternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink];
  icon?: InternIcon;
  text?: string;
}

export function isInternServiceLink(obj: { __component?: string }): obj is InternServiceLink {
  return obj.__component === 'intern.service-link';
}
